/* eslint-disable react/jsx-no-target-blank */
import { Link } from 'gatsby';
import React, { useEffect } from 'react';
import { isMobile, isTablet } from 'react-device-detect';
import { screenIs } from '../../utils/tailwindSize';
import { isLoggedIn } from '../../utils/auth';
import {
	AboutUsIcon,
	OurPoliciesIcon,
	ContactUsIcon,
	PartnersIcon,
	EventsIcon,
	BlogIcon
} from '../sidebar/icons';

const helpingMenuItems = [
	{
		name: 'Blog',
		url: 'https://support.djawn.com/category/blog/',
		icon: <BlogIcon />
	},
	{
		name: 'Partners',
		url: 'https://support.djawn.com/partners/',
		icon: <PartnersIcon />
	},
	{
		name: 'Contact Us',
		url: 'https://support.djawn.com/contact/',
		icon: <ContactUsIcon />
	},
	{
		name: 'About Us',
		url: 'https://support.djawn.com/about-us/',
		icon: <AboutUsIcon />
	},
	{
		name: 'Our Policies',
		url: 'https://support.djawn.com/terms-of-service/',
		icon: <OurPoliciesIcon />
	}
];

const Sidebar = ({ isOpen, setIsOpen }) => {
	useEffect(() => {
		// ipad size
		if (screenIs('md') && !isMobile) {
			if (setIsOpen) {
				setIsOpen(true);
			}
		}
		if (screenIs('xl') && isTablet) {
			if (setIsOpen) {
				setIsOpen(true);
			}
		}
	}, []);

	return (
		<div
			className={`fixed top-0 h-full z-40 pt-12 xxs:pt-12 xl:pt-16 pb-4 bg-white flex flex-wrap content-between w-60 border-0 xl:flex
			transform ${
		isOpen
			? 'translate-x-0 ease-out transition delay-75'
			: '-translate-x-full xl:-translate-x-0 ease-in transition delay-75'
		}
	`}
			style={{ zIndex: 20 }}
		>
			<div className="flex flex-wrap w-full p-0">
				<nav className="mt-0 w-full">
					<Link
						to="/"
						className="item mt-0 flex items-center text-base font-normal text-black w-full px-6 py-3 hover:bg-gray-200 active:bg-green-700"
						activeClassName="bg-gray-300"
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							className="mr-4"
							width="20"
							height="20"
							viewBox="0 0 20 20"
							fill="currentColor"
						>
							<path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
						</svg>
						<span className="item-text">Home</span>
					</Link>
					<Link
						to="/events"
						className="item mt-0 flex items-center text-base font-normal text-black w-full px-6 py-3 hover:bg-gray-200 active:bg-green-700"
						activeClassName="bg-gray-300"
					>
						<EventsIcon />
						<span className="item-text">Events</span>
					</Link>

					{isLoggedIn() && (
						<>
							<Link
								to="/favorite-events"
								className="item mt-0 flex items-center text-base font-normal text-black w-full px-6 py-3 hover:bg-gray-200 active:bg-green-700"
								activeClassName="bg-gray-300"
							>
								<svg
									className="mr-4"
									width="22"
									height="20"
									fill="none"
									stroke="currentColor"
									viewBox="0 0 24 24"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										strokeLinecap="round"
										strokeLinejoin="round"
										strokeWidth="2"
										d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
									/>
								</svg>
								<span className="item-text">My Favorites</span>
							</Link>
							<Link
								to="/my-events"
								className="item mt-0 flex items-center text-base font-normal text-black w-full px-6 py-3 hover:bg-gray-200 active:bg-green-700"
								activeClassName="bg-gray-300"
							>
								<svg
									className="mr-4"
									width="22"
									height="20"
									xmlns="http://www.w3.org/2000/svg"
									id="Layer_1"
									viewBox="0 0 511.998 511.998"
								>
									<g>
										<path d="m354.099 399.601-27.218-30.785-22.475 19.872 48.725 55.108 78.919-81.747-21.583-20.836z" />
										<path d="m369.451 265.331c-2.735 0-5.447.099-8.138.275l-8.698-148.885h-70.979v-28.95c-.001-48.397-39.375-87.771-87.772-87.771s-87.771 39.374-87.771 87.771v28.95h-70.98l-15.766 269.873c-1.227 21.013 6.051 41.018 20.494 56.329s33.989 23.743 55.037 23.743h179.112c22.636 27.652 57.021 45.332 95.461 45.332 68.006 0 123.333-55.327 123.333-123.333 0-68.007-55.327-123.334-123.333-123.334zm-233.359-177.56c0-31.855 25.916-57.771 57.771-57.771s57.772 25.916 57.772 57.771v28.95h-115.543zm-41.214 348.895c-12.702 0-24.498-5.089-33.214-14.329s-13.108-21.313-12.368-33.993l14.115-241.622h42.681v37.588h30v-37.588h115.543v37.588h30v-37.588h42.681l7.277 124.562c-49.541 16.016-85.475 62.578-85.475 117.382 0 17.017 3.465 33.24 9.725 48.001h-160.965zm274.573 45.332c-51.464 0-93.333-41.869-93.333-93.333 0-51.465 41.869-93.334 93.333-93.334s93.333 41.869 93.333 93.334c0 51.464-41.869 93.333-93.333 93.333z" />
									</g>
								</svg>
								<span className="item-text">My Events</span>
							</Link>
						</>
					)}

					<Link
						to="/live-feeds"
						className="item mt-0 flex items-center text-base font-normal text-black w-full px-6 py-3 hover:bg-gray-200 active:bg-green-700"
						activeClassName="bg-gray-300"
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							className="mr-4"
							width="22"
							height="20"
							viewBox="0 0 20 20"
							fill="currentColor"
						>
							<path
								fillrull="evenodd"
								d="M5.05 3.636a1 1 0 010 1.414 7 7 0 000 9.9 1 1 0 11-1.414 1.414 9 9 0 010-12.728 1 1 0 011.414 0zm9.9 0a1 1 0 011.414 0 9 9 0 010 12.728 1 1 0 11-1.414-1.414 7 7 0 000-9.9 1 1 0 010-1.414zM7.879 6.464a1 1 0 010 1.414 3 3 0 000 4.243 1 1 0 11-1.415 1.414 5 5 0 010-7.07 1 1 0 011.415 0zm4.242 0a1 1 0 011.415 0 5 5 0 010 7.072 1 1 0 01-1.415-1.415 3 3 0 000-4.242 1 1 0 010-1.415zM10 9a1 1 0 011 1v.01a1 1 0 11-2 0V10a1 1 0 011-1z"
								clipRule="evenodd"
							/>
						</svg>
						<span className="item-text">Live Now</span>
					</Link>

					<Link
						to="/past-events"
						className="item mt-0 flex items-center text-base font-normal text-black w-full px-6 py-3 hover:bg-gray-200 active:bg-green-700"
						activeClassName="bg-gray-300"
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							className="mr-4"
							width="22"
							height="20"
							fill="none"
							viewBox="0 0 24 24"
							stroke="currentColor"
						>
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								strokeWidth="2"
								d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01"
							/>
						</svg>
						<span className="item-text">Past Events</span>
					</Link>
					<Link
						to="/almost-full"
						className="item mt-0 flex items-center text-base font-normal text-black w-full px-6 py-3 hover:bg-gray-200 active:bg-green-700"
						activeClassName="bg-gray-300"
					>
						<svg
							className="mr-4"
							width="22"
							height="20"
							version="1.1"
							id="Layer_1"
							xmlns="http://www.w3.org/2000/svg"
							xmlnsXlink="http://www.w3.org/1999/xlink"
							x="0px"
							y="0px"
							viewBox="0 0 105.762 122.88"
							enableBackground="new 0 0 105.762 122.88"
							xmlSpace="preserve"
							fill="currentColor"
						>
							<g>
								<path d="M86.27,112.663c0.195-19.858-6.947-33.132-16.682-39.914c-3.773-2.629-7.914-4.284-12.133-4.97 c-4.236-0.685-8.583-0.408-12.747,0.828c-13.737,4.082-25.458,18.735-25.215,44.055L86.27,112.663L86.27,112.663L86.27,112.663z M19.977,19.522h65.814c0.346-2.922,0.514-6.025,0.479-9.307H19.496C19.462,13.498,19.629,16.6,19.977,19.522L19.977,19.522z M0.91,112.663h9.567c-0.256-27.544,12.171-44.634,27.549-51.198c-15.389-6.566-27.821-23.676-27.549-51.252L0.91,10.214 c-0.501,0-0.909-0.46-0.909-1.025L0,1.024C0,0.46,0.409,0,0.91,0h103.942c0.5,0,0.91,0.46,0.91,1.024v8.164 c0,0.564-0.41,1.025-0.91,1.025h-9.57c0.225,23.213-8.58,39.037-20.545,47.375c-2.188,1.522-4.543,2.832-6.994,3.873 c2.447,1.049,4.809,2.355,6.992,3.88c11.955,8.332,20.756,24.138,20.545,47.32l9.572,0.001c0.5,0,0.91,0.463,0.91,1.027v8.162 c0,0.564-0.41,1.027-0.91,1.027H0.91c-0.501,0-0.909-0.463-0.909-1.027v-8.162C0.001,113.126,0.41,112.663,0.91,112.663 L0.91,112.663z" />
							</g>
						</svg>
						<span className="item-text">Almost Full</span>
					</Link>
				</nav>
			</div>

			<div>
				<div className="flex flex-col">
					{helpingMenuItems.map((item, index) => (
						<div
							key={index}
							onClick={() => {
								window.open(item.url, '_blank');
							}}
							onKeyDown={() => {
								window.open(item.url, '_blank');
							}}
							className="cursor-pointer item mt-0 flex items-center text-base font-normal text-black w-full px-6 py-2 hover:bg-gray-200 active:bg-green-700"
						>
							{item.icon}
							<span className="item-text">{item.name}</span>
						</div>
					))}
					<div className="border-b-4" />
				</div>

				<div className="flex flex-wrap w-full px-8 py-4 pr-24 social-wrap">
					<nav className="w-full">
						<div className="item mt-0 flex items-center text-xs uppercase font-normal text-gray-400">
							<span className="tracking-wider item-text">Follow Us</span>
						</div>

						<div className="mt-3 xxs:mt-3 md:mt-3 flex items-center text-sm uppercase font-normal">
							<div className="flex social justify-between content-center w-full">
								<a
									href="https://www.facebook.com/Djawn-103815485008296"
									className="item flex items-center text-normal font-normal text-gray-500"
									target="_blank"
								>
									<span className="mx-auto">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											id="Bold"
											enableBackground="new 0 0 24 24"
											viewBox="0 0 24 24"
											height="16"
											width="16"
											fill="currentColor"
										>
											<path d="m15.997 3.985h2.191v-3.816c-.378-.052-1.678-.169-3.192-.169-3.159 0-5.323 1.987-5.323 5.639v3.361h-3.486v4.266h3.486v10.734h4.274v-10.733h3.345l.531-4.266h-3.877v-2.939c.001-1.233.333-2.077 2.051-2.077z" />
										</svg>
									</span>
								</a>

								<a
									href="https://www.instagram.com/djawnllc/"
									className="item flex items-center  text-normal font-normal text-gray-500"
									target="_blank"
								>
									<span className="mx-auto">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 511 511.9"
											height="16"
											width="16"
											fill="currentColor"
										>
											<path d="m510.949219 150.5c-1.199219-27.199219-5.597657-45.898438-11.898438-62.101562-6.5-17.199219-16.5-32.597657-29.601562-45.398438-12.800781-13-28.300781-23.101562-45.300781-29.5-16.296876-6.300781-34.898438-10.699219-62.097657-11.898438-27.402343-1.300781-36.101562-1.601562-105.601562-1.601562s-78.199219.300781-105.5 1.5c-27.199219 1.199219-45.898438 5.601562-62.097657 11.898438-17.203124 6.5-32.601562 16.5-45.402343 29.601562-13 12.800781-23.097657 28.300781-29.5 45.300781-6.300781 16.300781-10.699219 34.898438-11.898438 62.097657-1.300781 27.402343-1.601562 36.101562-1.601562 105.601562s.300781 78.199219 1.5 105.5c1.199219 27.199219 5.601562 45.898438 11.902343 62.101562 6.5 17.199219 16.597657 32.597657 29.597657 45.398438 12.800781 13 28.300781 23.101562 45.300781 29.5 16.300781 6.300781 34.898438 10.699219 62.101562 11.898438 27.296876 1.203124 36 1.5 105.5 1.5s78.199219-.296876 105.5-1.5c27.199219-1.199219 45.898438-5.597657 62.097657-11.898438 34.402343-13.300781 61.601562-40.5 74.902343-74.898438 6.296876-16.300781 10.699219-34.902343 11.898438-62.101562 1.199219-27.300781 1.5-36 1.5-105.5s-.101562-78.199219-1.300781-105.5zm-46.097657 209c-1.101562 25-5.300781 38.5-8.800781 47.5-8.601562 22.300781-26.300781 40-48.601562 48.601562-9 3.5-22.597657 7.699219-47.5 8.796876-27 1.203124-35.097657 1.5-103.398438 1.5s-76.5-.296876-103.402343-1.5c-25-1.097657-38.5-5.296876-47.5-8.796876-11.097657-4.101562-21.199219-10.601562-29.398438-19.101562-8.5-8.300781-15-18.300781-19.101562-29.398438-3.5-9-7.699219-22.601562-8.796876-47.5-1.203124-27-1.5-35.101562-1.5-103.402343s.296876-76.5 1.5-103.398438c1.097657-25 5.296876-38.5 8.796876-47.5 4.101562-11.101562 10.601562-21.199219 19.203124-29.402343 8.296876-8.5 18.296876-15 29.398438-19.097657 9-3.5 22.601562-7.699219 47.5-8.800781 27-1.199219 35.101562-1.5 103.398438-1.5 68.402343 0 76.5.300781 103.402343 1.5 25 1.101562 38.5 5.300781 47.5 8.800781 11.097657 4.097657 21.199219 10.597657 29.398438 19.097657 8.5 8.300781 15 18.300781 19.101562 29.402343 3.5 9 7.699219 22.597657 8.800781 47.5 1.199219 27 1.5 35.097657 1.5 103.398438s-.300781 76.300781-1.5 103.300781zm0 0" />
											<path d="m256.449219 124.5c-72.597657 0-131.5 58.898438-131.5 131.5s58.902343 131.5 131.5 131.5c72.601562 0 131.5-58.898438 131.5-131.5s-58.898438-131.5-131.5-131.5zm0 216.800781c-47.097657 0-85.300781-38.199219-85.300781-85.300781s38.203124-85.300781 85.300781-85.300781c47.101562 0 85.300781 38.199219 85.300781 85.300781s-38.199219 85.300781-85.300781 85.300781zm0 0" />
											<path d="m423.851562 119.300781c0 16.953125-13.746093 30.699219-30.703124 30.699219-16.953126 0-30.699219-13.746094-30.699219-30.699219 0-16.957031 13.746093-30.699219 30.699219-30.699219 16.957031 0 30.703124 13.742188 30.703124 30.699219zm0 0" />
										</svg>
									</span>
								</a>

								<a
									href="https://twitter.com/djawn4"
									className="item flex items-center text-normal font-normal text-gray-500"
									target="_blank"
								>
									<span className="mx-auto">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											id="Bold"
											enableBackground="new 0 0 24 24"
											viewBox="0 0 24 24"
											height="16"
											width="16"
											fill="currentColor"
										>
											<path d="m21.534 7.113c.976-.693 1.797-1.558 2.466-2.554v-.001c-.893.391-1.843.651-2.835.777 1.02-.609 1.799-1.566 2.165-2.719-.951.567-2.001.967-3.12 1.191-.903-.962-2.19-1.557-3.594-1.557-2.724 0-4.917 2.211-4.917 4.921 0 .39.033.765.114 1.122-4.09-.2-7.71-2.16-10.142-5.147-.424.737-.674 1.58-.674 2.487 0 1.704.877 3.214 2.186 4.089-.791-.015-1.566-.245-2.223-.606v.054c0 2.391 1.705 4.377 3.942 4.835-.401.11-.837.162-1.29.162-.315 0-.633-.018-.931-.084.637 1.948 2.447 3.381 4.597 3.428-1.674 1.309-3.8 2.098-6.101 2.098-.403 0-.79-.018-1.177-.067 2.18 1.405 4.762 2.208 7.548 2.208 8.683 0 14.342-7.244 13.986-14.637z" />
										</svg>
									</span>
								</a>
							</div>
						</div>
					</nav>
				</div>
			</div>
		</div>
	);
};

export default Sidebar;
